<template>
  <div>
    <Bar v-if="stepFlag === '1'">企业信息</Bar>
    <Bar v-if="stepFlag === '2'">项目信息</Bar>
    <div class="prevForm full-form-container" v-if="stepFlag === '1'">
      <el-form
        :model="form"
        ref="firstStepForm"
        :rules="firstRules"
        label-width="150px"
      >
        <el-form-item
          prop="bidderCompanyName"
          label="企业名称"
          class="form-item-full"
        >
          <el-input
            placeholder="请填写真实企业名称或标段（包）名称"
            v-model="form.bidderCompanyName"
            :disabled="isHlj"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="orgLegalPerson"
          label="企业法人"
          class="form-item-full"
        >
          <el-input
            placeholder="请填写企业法人名称"
            v-model="form.orgLegalPerson"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item
          prop="bidderSocialCreditCode"
          label="统一社会信用代码"
          class="form-item-full"
        >
          <el-input
            placeholder="未三证合一请填写组织机构代码  "
            v-model="form.bidderSocialCreditCode"
          ></el-input>
        </el-form-item>
        <el-button
          type="text"
          style="margin-left: 160px"
          @click="to('https://www.cods.org.cn/')"
          >点此查询统一社会信用代码</el-button
        > -->
        <el-form-item
          prop="bidderLinkName"
          label="联系人"
          class="form-item-full"
        >
          <el-input
            placeholder="请填写联系人姓名（保函申请人姓名）"
            v-model="form.bidderLinkName"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="bidderMobilePhone"
          label="联系方式"
          class="form-item-full"
        >
          <el-input
            placeholder="请填写联系人手机号（保函申请人手机号）"
            v-model="form.bidderMobilePhone"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button plain v-if="!$route.query.orderID" @click="saveDraft" :loading="draftSaving">保存</el-button>
          <el-button type="primary" @click="nextStep">下一步</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="nextForm full-form-container" v-if="stepFlag === '2'">
      <el-form
        :model="form"
        ref="secondStepForm"
        :rules="secondRules"
        label-width="150px"
      >
      <el-form-item
          v-if="isCQSW"
          prop="bhType"
          label="保函类型"
          class="form-item-full"
          ref="bhType"
        >
          <el-select v-model="form.bhType" placeholder="请选择保函类型" @change="bhTypeChange">
            <el-option
              v-for="item in bhTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="projectName"
          label="标段名称"
          class="form-item-full"
        >
        <el-autocomplete
          v-model="form.projectName"
          class="inline-input"
          placeholder="请填写真实项目名称或标段（包）名称"
            style="width: 400px;"
          :fetch-suggestions="querySearch"
          :trigger-on-focus="false"
          :disabled="isHlj"
        />
        </el-form-item>
        <!-- <el-form-item
          prop="projectCode"
          label="标段编号"
          class="form-item-full"
        >
          <el-input
            placeholder="请填写真实项目名称或标段（包）编号"
            v-model="form.projectCode"
          ></el-input>
        </el-form-item> -->
        <el-form-item
          prop="tenderCompanyName"
          label="招标人名称"
          class="form-item-full"
        >
          <el-input
            placeholder="请填写招标人全称，非代理机构名称  "
            v-model="form.tenderCompanyName"
            :disabled="isHlj"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="performGuaranteeType"
          label="保函类型"
          class="form-item-full"
          style="width: 800px"
        >
        <el-radio-group v-model="form.performGuaranteeType" >
            <el-radio  v-for="item in performGuaranteeTypeOptions"   :key="item.valuesetKey"  :label="item.valuesetKey">{{item.valuesetValue}}</el-radio>
        </el-radio-group>
        </el-form-item>
        <el-form-item
          prop="performanceGuaranteePeriod"
          label="担保期限"
          class="form-item-full"
        >
        <el-col :span="20">
          <el-input
            placeholder="请填写担保期限(天)"
            v-model="form.performanceGuaranteePeriod"
          ></el-input>
    </el-col>
    <el-col class="line" style="margin-left: 10px" :span="3">单位(天)</el-col>
        </el-form-item>
        <el-form-item prop="rojectArea" label="项目地区" class="form-item-full">
          <el-cascader
            v-model="form.rojectArea"
            :options="options"
            @change="cascaderHandleChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item
          prop="guaranteeAmount"
          label="担保金额(万元)"
          class="form-item-full"
        >
          <el-input
            placeholder="请填写履约保证金金额"
            v-model="form.guaranteeAmount"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="writingParty"
          label="出函方"
          class="form-item-full"
        >
          <el-select v-model="form.writingParty" placeholder="请选择出函方">
            <el-option
              v-for="item in senderOptions"
              :key="item.valuesetKey"
              :label="item.valuesetValue"
              :value="item.valuesetKey"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="是否具有企业资质"
          class="form-item-full"
          prop="bidderQualification"
        >
          <el-radio-group v-model="form.bidderQualification">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="form.bidderQualification === '1'"
          label="企业资质相关文件"
          prop="dutyPaidProof"
          class="form-item-full"
        >
          <uploadE
            actionUrl="/zcjf/base/file/upload"
            uploadTitle="上传企业资质相关文件"
            @fileIdCb="uploadDutyPaidProof"
            :fileId="form.dutyPaidProof"
            accept =".pdf, .doc, .docx, .rar, .zip, .jpg, .bmp, .gif, .png, .jpeg"
            :filetypes = "['pdf','doc','docx','rar','zip','jpg','bmp','gif','png','jpeg']"
          >
            <template #explain>
              <ul slot="tip" class="el-upload__tip">
                <li>
                  请上传格式为PDF、WORD、RAR、ZIP、JPG、BMP、GIF、PNG、JPEG的资质文件，若有多个文件请压缩成一个zip文件
                </li>
              </ul>
            </template></uploadE
          >
        </el-form-item>
        <el-form-item
          label="招标文件"
          prop="tenderFileId"
          class="form-item-full"
        >
          <uploadE
            actionUrl="/zcjf/base/file/upload"
            uploadTitle="上传招标文件"
            @fileIdCb="uploadSuccessOrTender"
             accept =".pdf, .doc, .docx, .rar, .zip, .jpg, .bmp, .gif, .png, .jpeg"
            :fileId="form.tenderFileId"
            :filetypes = "['pdf','doc','docx','rar','zip','jpg','bmp','gif','png','jpeg']"

          >
            <template #explain>
              <ul slot="tip" class="el-upload__tip">
                <!-- <li>补遗、澄清等相关文件，请与招标文件一起打包上传</li> -->
                <li>支持PDF、WORD、RAR、ZIP、JPG、BMP、GIF、PNG、JPEG文档</li>
              </ul>
            </template></uploadE
          >
        </el-form-item>
        <el-form-item
          label="中标通知书"
          prop="tenderMateriaFileId"
          class="form-item-full"
        >
          <uploadE
            actionUrl="/zcjf/base/file/upload"
            uploadTitle="上传中标通知书"
            @fileIdCb="uploadSuccess"
            :fileId="form.tenderMateriaFileId"
          >
            <template #explain>
              <div slot="tip" class="el-upload__tip">
                支持PDF、WORD、RAR、ZIP、JPG、BMP、GIF、PNG、JPEG文档
              </div>
            </template></uploadE
          >
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="stepFlag = '1'"
            >上一步</el-button
          >
          <el-button plain v-if="!$route.query.orderID" @click="saveDraft" :loading="draftSaving">保存</el-button>
          <el-button type="primary" @click="submitHandler">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { data } from '../../../util/cityData'
import uploadE from '../../../common/upload/uoload.vue'
import { submitPerformance,querySysValueData,querySysValueDataList } from '../../../api/comm'
import { fiterData } from '@/util/dataForma'
import Bar from '@/components/Bar/bar'
import {
  mapMutations,
  PERFORMANCE,
} from '@/store/modules/performance'
import { to, renderArea } from '@/shared/location'
import { isLogin, showLogin } from '@/shared/user'
import { cloneDeep } from 'lodash'
import { bidderMobilePhonePass, bidderLinkMailPass } from '@/shared/validate'
import { queryOrderDetail ,queryOrderByOuterOrderNo} from '@/api/order'
import { mapGetters, CONFIG_GETTERS } from '@/store/modules/config'
import {
  queryPackageNames
} from '@/api/dataForms'
import { ORDER_TYPE, checkGuaranteeDraft, saveCurrentDraft, clearCurrentDraft } from '@/shared/guaranteeDraft'
export default {
  name: 'firstStepForm',
  components: {
    Bar,
    uploadE,
  },
  data() {
    const businessLicensePass = (rule, value, callback) => {
      if (this.form.tenderFileId) {
        callback()
      } else {
        callback(new Error('请上传招标文件'))
      }
    }

    const businessPaidProof = (rule, value, callback) => {
      if (this.form.dutyPaidProof) {
        callback()
      } else {
        callback(new Error('请上传资质文件'))
      }
    }

    return {
      isCQSW:'',
      draftSaving: false,
      bhTypeList:[
        {label:'履约保函',value:'9100'},
        {label:'预付款保函',value:'9200'},
        {label:'质量保函',value:'9300'},
        {label:'农民工工资保函',value:'9400'},
      ],
      options: data,
      stepFlag: '1',
      firstRules: {
        bidderCompanyName: [
          {
            required: true,
            message: '请填写企业名称',
          },
        ],
        orgLegalPerson: [
          {
            required: true,
            message: '请填写企业法人',
          },
        ],
        bidderSocialCreditCode: [
          {
            required: true,
            message: '请填写统一社会信用代码',
          },
        ],
        bidderLinkName: [
          {
            required: true,
            message: '请填写联系人',
          },
        ],
        bidderMobilePhone: [
          {
            required: true,
            validator: bidderMobilePhonePass,
            message: '请填写联系方式',
          },
        ],
      },
      secondRules: {
        rojectArea: { required: true, message: '请选择项目地区' },
        bhType: { required: true, message: '请选择保函类型',trigger: 'change'  },
        projectName: [
          {
            required: true,
            message: '请填写真实项目名称或标段（包）名称',
          },
        ],
        projectCode: [
          {
            required: true,
            message: '请填写真实项目名称或标段（包）编号',
          },
        ],
        tenderCompanyName: [
          {
            required: true,
            message: '请填写招标人全称，非代理机构名称',
          },
        ],
        performanceGuaranteePeriod: [
          {
            required: true,
            message: '请填写担保期限(天)',
          },
        ],
        guaranteeAmount: [
          {
            required: true,
            message: '请填写履约保证金金额',
          },
        ],
        writingParty: [
          {
            required: true,
            message: '请选择出函方',
          },
        ],
        performGuaranteeType: [
          {
            required: true,
            message: '保函类型',
          },
        ],
        bidderQualification: [
          {
            required: true,
            message: '请选择是否具有企业资质',
          },
        ],
        tenderFileId: [
          {
            required: true,
            validator: businessLicensePass,
          },
        ],
        dutyPaidProof: {
          required: true,
          validator: businessPaidProof,
        },
      },
      form: {
        performGuaranteeType:'9100'
      },
      senderOptions: [],
      performGuaranteeTypeOptions: [],
      confirmForm: {},
      isCqsw:this.$store.state.letter.isCqsw,
      applyType: this.$store.state.letter.applyType
    }
  },
  computed: {
    ...mapGetters({
      isZCMOrigin: CONFIG_GETTERS.IS_ZCM_ORIGIN,
    }),
    isHlj() {
      return this.$store.state.letter.isHlj
    }
  },
  async created() {
    const { orderID, outerOrderNo, reapply } = this.$route.query
    const isNewOrder = !orderID

    if (isNewOrder) {
      const shown = await checkGuaranteeDraft(this, ORDER_TYPE.PERFORMANCE_9100, {
        restore: (draft) => {
          if (draft.formData) {
            // 先加载系统值数据（senderOptions 等），再恢复表单
            this.loadSysValueData()
            this.form = { ...this.form, ...draft.formData }
            this.form.rojectArea = renderArea(draft.formData)
            this.form.reapply = reapply
            // 根据保存的 step 决定停留在 stepFlag '1' 还是 '2'
            const savedStep = draft.step
            if (savedStep === '2' || savedStep === 2) {
              this.stepFlag = '2'
              this.performance(draft.formData)
            } else {
              this.stepFlag = '1'
            }
            if (this.isCqsw && this.applyType === '9100') {
              this.senderOptions = [{ label: '银行', value: '2' }]
            }
            this.setDefPerformGuaranteeType()
          }
        },
        skipRestore: () => {
          // 重新申请 —— 先清 Vuex 旧表单，再走正常初始化
          this.clear()
          this.doInit(orderID, outerOrderNo, reapply)
        },
      })
      // shown=true 表示已弹窗让用户选择，回调里已经处理了，不需要再走 init
      if (!shown) {
        this.doInit(orderID, outerOrderNo, reapply)
      }
    } else {
      this.doInit(orderID, outerOrderNo, reapply)
    }
  },
  methods: {
    doInit(orderID, outerOrderNo, reapply) {
      this.loadSysValueData()
      this.form.reapply = reapply
      if (orderID) {
        queryOrderDetail(orderID).then((res) => {
          this.clear()
          this.performance(res.data)
          this.form = res.data
          this.form.rojectArea = renderArea(res.data)
          this.form.reapply = reapply
          this.setDefPerformGuaranteeType()
        })
      } else if (outerOrderNo) {
        queryOrderByOuterOrderNo(outerOrderNo).then((v) => {
          if (v.data.orderId) {
            this.$router.replace({
              path: this.$route.path,
              query: {
                ...this.$route.query,
                orderID: v.data.orderId,
              },
            })
          }

          this.form = v.data.model
          this.form.rojectArea = renderArea(v.data.model)
          this.$set(this.form, 'performanceGuaranteePeriod', v.data.model.delayProof)
          this.form.reapply = reapply
          this.setDefPerformGuaranteeType()
        })
      } else {
        // 新建场景，form 在 data() 已初始化，不再读任何本地/Vuex 缓存
      }
      if (this.isCqsw && this.applyType === '9100') {
        this.senderOptions = [
          {
            label: '银行',
            value: '2',
          },
        ]
      }
      this.setDefPerformGuaranteeType()
    },
    setDefPerformGuaranteeType(){
      if(!this.form.performGuaranteeType){
      this.$set(this.form, 'performGuaranteeType', '9100')
    }
    },
    async loadSysValueData() {
      try {
        const res = await querySysValueDataList({
          key: 'PERFORMANCE_GUARANTEE_TYPE,PERFORM_GUARANTEE_TYPE'
        })
        const targetItem = res.data?.find(item => item.key === 'PERFORMANCE_GUARANTEE_TYPE') || {}
        const performItem = res.data?.find(item => item.key === 'PERFORM_GUARANTEE_TYPE') || {}
        const dataList = targetItem.data || []
        const performList = performItem.data || []
        this.senderOptions = cloneDeep(dataList)
        this.performGuaranteeTypeOptions = cloneDeep(performList)
      } catch (err) {
        console.error('加载系统值数据失败：', err)
        this.senderOptions = []
        this.performGuaranteeTypeOptions = []
        // this.$message.error('加载配置数据失败，请刷新页面重试')
      }
    },
    querySearch(queryString, cb) {
      queryPackageNames({ packageName: queryString }).then(v => {
        if (v.code === 200) {
          const processedData = v.data.map(str => {
            return {
              value: str,
              label: str
            }
          })
          // 调用 callback 返回建议列表的数据
          cb(processedData)
        }
      })
    },

    ...mapMutations({
      performance: PERFORMANCE.PERFORMANCE,
      clear: PERFORMANCE.CLEAR,
    }),
    to: to,
    uploadSuccess(res) {
      this.form.tenderMateriaFileId = res.url
    },
    uploadSuccessOrTender(res) {
      this.form.tenderFileId = res.url
    },
    uploadDutyPaidProof(res) {
      this.form.dutyPaidProof = res.url
    },
    cascaderHandleChange(e) {
      const [province, city, district] = [e[0], e[1], e[2]]
      this.form = Object.assign(this.form, {
        province: province,
        district: district,
        city: city,
      })
    },
    nextStep() {
      this.$refs.firstStepForm.validate((valid) => {
        if (valid) {
          this.stepFlag = '2'
          this.performance(this.form)
        }
      })
    },
    async saveDraft() {
      this.draftSaving = true
      try {
        const step = this.stepFlag === '1' ? '1' : '2'
        await saveCurrentDraft(this, ORDER_TYPE.PERFORMANCE_9100, step, this.form)
      } finally {
        this.draftSaving = false
      }
    },
    submitHandler() {
      if (!isLogin()) {
        showLogin()
        return false
      }
      this.$refs.secondStepForm.validate(async (valid) => {
        if (valid) {
          const form = cloneDeep(this.form)
          this.form.orderType = '9100'
          form.performGuaranteeType = this.performGuaranteeTypeOptions.filter(item => item.valuesetKey === this.form.performGuaranteeType)[0].valuesetValue
          form.writingParty = this.senderOptions.filter(item => item.valuesetKey === this.form.writingParty)[0].valuesetValue
          await fiterData(form)
          this.$showAffirm(form, '9100').then(() => {
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
            })
            if (this.isZCMOrigin) {
              this.form.apiId = 'zcm'
              this.form.apiAccessConfigId = 8
            }
            submitPerformance(this.form).then((res) => {
              loading.close()
              this.clear()
              // 提交成功，清空 Redis 草稿
              clearCurrentDraft(this, ORDER_TYPE.PERFORMANCE_9100)
              this.$router.push({
                name: 'orderDetail',
                query: { order: res.data },
              })
            })
          })
        }
      })
    },
    bhTypeChange(){
      this.$refs.bhType.clearValidate()
    },
  },
}
</script>

<style scoped>
.flexRight {
  position: absolute;
  right: 7%;
}
.full-form-container {
  width: 50%;
  margin: 5rem auto 0;
  padding: 10px 0;
}

</style>
